/**
 * @fileoverview Forgot-password page.
 * @description Composes the auth page shell with the forgot-password card. Route-level only — the
 * actual form, validation, and submit logic live in ForgotPasswordForm/useRequestPasswordReset.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { ForgotPasswordCard } from '@/features/auth'
import AuthLayout from '@/shared/components/layouts/AuthLayout'

/**
 * @component
 */
function ForgotPasswordPage() {
  return (
    <AuthLayout>
      <ForgotPasswordCard />
    </AuthLayout>
  )
}

export default ForgotPasswordPage
